import { useMutation } from '@tanstack/react-query'
import { useAuthStore } from '@/store/authStore'
import { authApi } from '@/services/auth/authApi'
import { LoginCredentials } from '@/interfaces/auth'
import { toast } from 'react-toastify'
import { handleError } from '@/utils/helpers'

export const useLogin = () => {
  const setAuth = useAuthStore((state) => state.setAuth)

  return useMutation({
    mutationFn: async (credentials: LoginCredentials) => {
      // Step 1: Login to get token
      const loginResponse = await authApi.login(credentials)

      // Step 2: Store tokens in localStorage so interceptor can use it
      localStorage.setItem('token', loginResponse.token)
      if (loginResponse.refreshToken) {
        localStorage.setItem('refreshToken', loginResponse.refreshToken)
      }

      // Step 3: Get current user (interceptor will add token automatically)
      const user = await authApi.getMe()

      return { token: loginResponse.token, refreshToken: loginResponse.refreshToken, user }
    },
    onSuccess: (data) => {
      // Store user data and auth provider (token already stored in mutationFn)
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('auth_provider', 'credentials')

      // Update Zustand state
      setAuth({
        isAuthenticated: true,
        token: data.token,
        user: data.user,
      })

      toast.success('Đăng nhập thành công!')
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi đăng nhập' })
    },
  })
}

// Login with hardcoded token (for testing)
export const useTokenLogin = () => {
  const setAuth = useAuthStore((state) => state.setAuth)

  return useMutation({
    mutationFn: async (token: string) => {
      // Step 1: Login with token
      const loginResponse = await authApi.loginWithToken(token)

      // Step 2: Store tokens in localStorage so interceptor can use it
      localStorage.setItem('token', loginResponse.token)
      if (loginResponse.refreshToken) {
        localStorage.setItem('refreshToken', loginResponse.refreshToken)
      }

      // Step 3: Get current user (interceptor will add token automatically)
      // const user = await authApi.getMe()

      return {
        token: loginResponse.token,
        refreshToken: loginResponse.refreshToken,
        user: loginResponse.user,
      }
    },
    onSuccess: (data) => {
      // Store user data and auth provider (token already stored in mutationFn)
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('auth_provider', 'token')

      // Update Zustand state
      setAuth({
        isAuthenticated: true,
        token: data.token,
        user: data.user,
      })

      toast.success('Đăng nhập thành công!')
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi đăng nhập' })
    },
  })
}
